import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { learn_more_active: false };
    }

    render({ lists, code }) {
        const list = lists.filter(list => list.code === code)[0];

        let status = 'not-subscribed';
        if (list.subscribed) {
            status = list.intent ? 'unsubscribe' : 'subscribed';
        } else if (list.intent) {
            status = 'subscribe';
        }

        const list_button_class = 'email-button ' + status;

        const list_button_text = status.replace('-', ' ');

        return (
            <member-email-preference-list>
                <row className='is-wrap'>
                    <column className='is-9 has-padding-10-right'>
                        <h3>{list.name}</h3>
                        <p className='has-text-size-13 has-line-height-21 has-margin-10-bottom'>
                            {list.description}
                        </p>
                    </column>
                    <column className='is-3'>
                        <a href='#' onClick={(e) => this.toggleListStatus(list, e)} className={list_button_class}>
                            <span>{list_button_text}</span>
                        </a>
                    </column>
                </row>
            </member-email-preference-list>
        );
    }

    toggleListStatus = (list, e) => {
        e.preventDefault();

        const lists = this.props.lists.map(l => {
            if (l.code === list.code) {
                return { ...l, intent: !l.intent };
            }

            return l;
        });

        const dirty = lists.some(list => list.intent);

        this.props.updateLists({
            lists: lists,
            dirty: dirty,
        });
    }
}

const mapStateToProps = (state) => ({
    lists: state['mail-lists'] && state['mail-lists'].lists,
});

const mapDispatchToProps = (dispatch) => ({
    updateLists: (payload) => dispatch({
        type: 'mail-lists:update',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);


